import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../../../shared/modal/dialog';

function DeleteAttachmentConfirmPopup(props: any) {
  const { t } = useTranslation();
  const name = props.selection ? props.selection.name : '';

  return (
    <ModalDialog
      onSubmit={props.onSubmit}
      onClose={props.onClose}
      width="500px"
      {...props}
      actionText={t('warrant.attachment.deletePopup.action')}
      displayMessage={t('warrant.attachment.deletePopup.message', { name })}
    />
  );
}

export default DeleteAttachmentConfirmPopup;
